// extracted by mini-css-extract-plugin
export default {"back-button-container":"BackButton_back-button-container__Buf25","back-button-span":"BackButton_back-button-span__0CoR1","back-button-icon":"BackButton_back-button-icon__wk4PY"};